import moment from "moment";
// Checks Reducer

const ChecksReducerDefaultState = [];

export default (state = ChecksReducerDefaultState, action) => {
  switch (action.type) {
    case "ADD_CHECK":
      return [...state, action.check].sort((a, b) => {
        if (moment(a.creation_time).isBefore(moment(b.creation_time))) {
          return 1;
        } else if (moment(a.creation_time).isAfter(moment(b.creation_time))) {
          return -1;
        }
        return 0;
      });
    case "REMOVE_CHECK":
      return state.filter(({ id }) => id !== action.id);
    case "EDIT_CHECK":
      return state.map(check => {
        if (check.id === action.id) {
          const temp = {
            ...action.updates.data,
            monthly_metrics: check.data ? check.data.monthly_metrics : {}
          };
          return { ...check, ...action.updates, data: temp };
        } else {
          return check;
        }
      });
    case "CLEAR_CHECKS":
      return [];
    default:
      return state;
  }
};
